import { JS2Native, env, coolHref } from '@utils';
import { getUser } from '@utils/auth';
import { getOutsideAuth } from '@utils/outsideAuth';
import router from '../router/index.js';

// 设置页面标题
export function setPageTitle(title = '少年得到') {
  if (env.isApp) {
    JS2Native({
      name: 'setPageTitle',
      params: {
        title,
      }
    });
  } else {
    document.title = title;
  }
}

// 解析地址中的参数
export function getUrlParam(url) {
  if (!url) {
    return {};
  }

  let result = {};
  let index = url.indexOf('?');
  if (index > -1) {
    url = url.slice(index + 1);
  }
  let paramItems = url.split('&');
  for (let i = 0; i < paramItems.length; i++) {
    const paramKey = paramItems[i].split('=')[0];
    const paramValue = paramItems[i].split('=')[1];
    result[paramKey] = paramValue;
  }
  return result;
}

// 地址跳转
export function jumpTo(data) {
  const { jumpType, jumpUrl, replaceTo, useRouter = true, needUrl, isApp = false } = data;
  const { linkType, linkRoute } = getUrlParam(jumpUrl);
  // linkType 1: 常规(itemid) 2: 拼团(itemid) 3: 小货架(activityId) 4: 静态活动(activityId) 5: 组合商品（combineId） 8: 会员卡
  if (jumpUrl) {
    if (jumpUrl.startsWith('https://') || jumpUrl.startsWith('http://')) {
      if (replaceTo) {
        window.location.replace(jumpUrl);
      } else if (isApp) {
        // @aigc:start 2024/04/11-14:27
        // 如果是在app内使用coolHref跳转
        coolHref(jumpUrl);
        // @aigc:end 2024/04/11-14:27
      } else {
        window.location.href = jumpUrl;
      }
      return;
    }

    let url = '';
    if (linkType == 1) {
      url = `/mall/course${jumpUrl}`;
    } else if (linkType == 2) {
      url = `/mall/course${jumpUrl}`;
    } else if (linkType == 3) {
      url = `/mall/shoppingPolymerize${jumpUrl}`;
    } else if (linkType == 5) {
      url = `/mall/combine${jumpUrl}`;
    } else if (linkType == 8) {
      // 判断如果在app内，使用coolHref跳转
      url = `/mall/vipCard${jumpUrl}`;
    }

    if (!url) {
      return;
    }

    if (needUrl) {
      return url;
    }

    if (linkType == 8 && env.isApp) {
      coolHref(window.location.origin + url);
      return;
    }

    if (!useRouter) {
      if (replaceTo) {
        window.location.replace(url);
      } else if (isApp) {
        // @aigc:start 2024/04/11-14:27
        // 如果是在app内使用coolHref跳转
        coolHref(window.location.origin + url);
        // @aigc:end 2024/04/11-14:27
      } else {
        window.location.href = url;
      }
      return;
    }

    if (replaceTo) {
      router.replace({
        path: url
      });
    } else {
      router.push({
        path: url
      });
    }
  }
}

// 跳转修改地址时需要获取的参数
export function getOtherQuery(query) {
  return Object.keys(query).reduce((acc, cur) => {
    if (
      cur !== 'address_id'
      && cur !== 'igc_pre_order_id'
      && cur !== 'igc_order_status'
    ) {
      acc[cur] = query[cur];
    }
    return acc;
  }, {});
}

// 生成请求头
export function createHeaders() {
  const headers = {};
  const userInfo = JSON.parse(getUser()) || {};
  let putType = 1;
  if (env.isApp) {
    putType = 2;
    headers['Shop-PutType'] = putType;
    headers['App-Device-Key'] = userInfo['App-Device-Key'];
    headers['App-Device-Du-Key'] = userInfo['App-Device-Du-Key'];
    headers['App-Device-Type'] = userInfo['App-Device-Type'];
    headers['APP-Agent'] = userInfo['APP-Agent'];
    headers['App-Sign'] = userInfo['App-Sign'];
    headers['App-User-Pid'] = userInfo['uid'];
    headers['App-Channel'] = userInfo['App-Channel'];
    headers['App-Version'] = userInfo['App-Version'];
    headers['isLogin'] = userInfo['isLogin'];
  } else {
    headers['Shop-PutType'] = putType;
    headers['App-User-Pid'] = userInfo['uid'];
    headers['Shop-Authorization'] = userInfo['token'];
  }

  // 蔚来汽车带过来的用户信息
  const outsideAuthInfo = getOutsideAuth();
  if (outsideAuthInfo) {
    headers['Outside-Token'] = outsideAuthInfo.appId + ',' + outsideAuthInfo.unionId + ',' + outsideAuthInfo.token;
  }

  return headers;
}

// @aigc:start 2024/07/18-18:51
// 获取设备类型  用户设备类型 0 ios 1 安卓  5 鸿蒙
export function getDeviceType() {
  let deviceType = env.isIOSApp ? 0 : 1;
  if (env.isIOSApp || env.isIOS) {
    deviceType = 0;
  } else if (env.isHarmonyApp || env.isHarmony) {
    deviceType = 5;
  } else {
    deviceType = 1;
  }
  return deviceType;
}
// @aigc:end 2024/07/18-18:51


// 跳转客服
// @aigc:start 2024/07/23-16:39
export function jumpToService({ channel }) {
  const user = JSON.parse(localStorage.getItem('IGetCool-USER-Info')) || {};
  let url = `https://webchat.7moor.com/wapchat.html?accessId=7b3019f0-c57b-11e9-9f01-8969b6bbf727&language=ZHCN&fromUrl=${encodeURIComponent(location.href)}&urlTitle=少年得到&otherParams=${
    JSON.stringify({
      userId: user.uid,
      priority: false,
      nickName: user.phone || user['App-nickName']
    })
  }&customField=${
    JSON.stringify({
      '手机号': user.phone || user['App-nickName'],
      'uid': user.uid,
      'channel': channel
    })
  }`;
  coolHref(url);
}
// @aigc:end 2024/07/23-16:39


// @aigc:start 2024/07/31-13:16
// 下载app
export function downloadApp() {
  if (env.isIOS) {
    location.href = 'itms-apps://itunes.apple.com/cn/app/id1279715325?mt=8';
  } else if (env.isHarmony) {
    location.href = 'store://appgallery.huawei.com/app/detail?id=com.igetcool.app';
  } else {
    location.href = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.dedao.juvenile';
  }
}
// @aigc:end 2024/07/31-13:16
